<template>
    <nav :class="['navbar', {'navbar-collapsed': isScrolled, 'navbar-left': isScrolledDelay}]">
        <div class="hamburger-icon" v-if="isScrolled">
            <span></span>
            <span></span>
            <span></span>
        </div>
        <div class="nav-links" :class="{'nav-links-collapsed': isScrolled}">
            <router-link to="/" class="nav-item">Accueil</router-link>
            <router-link to="/projets" class="nav-item">Mes Projets</router-link>
            <router-link to="/certifications" class="nav-item">Mes certifications</router-link>
            <router-link to="/cv" class="nav-item">Mon CV</router-link>
            <router-link to="/grille" class="nav-item">Grille d'évaluation</router-link>
        </div>
    </nav>
</template>

<script>
export default {
    name: 'NavigationBar',
    data() {
        return {
            isScrolled: false,
            isScrolledDelay: false,
            isExpanded: false,
            lastScrollY: 0
        }
    },
    mounted() {
        window.addEventListener('scroll', this.handleScroll)
        this.lastScrollY = window.scrollY
    },
    methods: {
        handleScroll() {
            const currentScrollY = window.scrollY

            if (currentScrollY <= 100) {
                // Retour en haut instantané
                this.isScrolled = false
                setTimeout(() => {
                    this.isScrolledDelay = false
                }, 0)
            } else if (currentScrollY > 100) {
                // Animation lors du défilement vers le bas
                this.isScrolled = true
                setTimeout(() => {
                    if (currentScrollY > 100) {
                        this.isScrolledDelay = true
                    }
                }, 300)
            }

            this.lastScrollY = currentScrollY
        },
        toggleNav() {
            if (this.isScrolled) {
                this.isExpanded = !this.isExpanded
            }
        }
    }
}
</script>

<style scoped>
.navbar {
    position: fixed;
    top: 2rem;
    left: 50%;
    transform: translateX(-50%);
    width: fit-content;
    background-color: rgba(1, 1, 11, 0.95);
    padding: 1rem 3rem;
    border-radius: 50px;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
    z-index: 1000;
    transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
}

.navbar-collapsed {
    padding: 1rem;
    border-radius: 50%;
    width: 50px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
}

.navbar-collapsed.navbar-left {
    left: 2rem;
    transform: translateX(0);
}

.navbar-collapsed:hover {
    border-radius: 15px;
    width: 220px;
    height: 180px;
}

.nav-links {
    display: flex;
    justify-content: center;
    gap: 2rem;
    transition: all 0.5s ease;
}

.nav-item {
    color: white;
    text-decoration: none;
    font-size: 1.2rem;
    padding: 0.5rem 1rem;
    transition: all 0.3s ease;
    white-space: nowrap;
}

.nav-item:hover {
    color: #cccccc;
    transform: translateY(-2px);
}

.nav-links-collapsed {
    flex-direction: column;
    width: 0;
    overflow: hidden;
    gap: 0;
    opacity: 0;
    visibility: hidden;
    transition: all 0.3s ease;
}

.navbar-collapsed .nav-links {
    flex-direction: column;
    gap: 1rem;
    padding: 1rem 1rem 1rem 50px;
}

.navbar-collapsed:hover .nav-links-collapsed {
    width: auto;
    gap: 1rem;
    padding: 1rem 1rem 1rem 50px;
    opacity: 1;
    visibility: visible;
    transition: opacity 0.5s ease 0.5s, visibility 0.5s ease 0.5s;
}

.hamburger-icon {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: column;
    gap: 5px;
}

.hamburger-icon span {
    display: block;
    width: 25px;
    height: 3px;
    background-color: white;
    border-radius: 3px;
}

.navbar-collapsed:hover .hamburger-icon {
    left: 12px;
    transform: translateY(-50%);
}
</style>
